// export const IMG_URL = "http://127.0.0.1:1919";
// export const IMG_URL = "https://mywealth-node.profcymabackend.com:1919";

export const IMG_URL = "https://mywealthwave.hostelbliss.com:4343";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};
